/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemTextInputFormatNameAllOf } from './formPagePropertyItemTextInputFormatNameAllOf';
import { FormPagePropertyItemTextInputFormatNameTextBox } from './formPagePropertyItemTextInputFormatNameTextBox';


/**
 * 姓名が別の文字列入力形式（姓名の間に全角スペースが入る）
 */
export interface FormPagePropertyItemTextInputFormatName { 
    /**
    * 入力形式を定める文字列
    */
    inputType: 'name';
    lastName: FormPagePropertyItemTextInputFormatNameTextBox;
    firstName: FormPagePropertyItemTextInputFormatNameTextBox;
    /**
    * 姓と名の区切り文字
    */
    delimiter: FormPagePropertyItemTextInputFormatName.DelimiterEnum;
}

export namespace FormPagePropertyItemTextInputFormatName {
    export type DelimiterEnum = '　';
    export const DelimiterEnum = {
        FullWidthSpace: '　' as DelimiterEnum
    };
}


